import React from 'react';
import Linkify from 'react-linkify';
import { LINKIFY_PROPERTIES } from 'configureLinkify';
import ExternalLink from 'components/ExternalLink';
import { isPublicCm } from 'utils/roles';

function AdminLinkify({ author, children }) {
  if (isPublicCm(author)) {
    return (
      <Linkify properties={LINKIFY_PROPERTIES} component={ExternalLink}>
        {children}
      </Linkify>
    );
  } else {
    return children;
  }
}

export default AdminLinkify;
